import { ConfirmFieldDef } from './report-confirm-card/report-confirm-card.component';

/**
 * 语音报报告字段定义（前端）。
 *
 * 用于：
 * - 确认卡片渲染（字段 label、可编辑性、多行）
 * - 报告类型 OTI/LP 的字段展示顺序
 *
 * 与 requirements/deviation-report/report-field-constraints.ts 的 key 保持一致。
 */

/** 通用（车辆基础）字段：来自 check-in/车辆档案预填，只读展示 */
export const BASIC_FIELDS: ConfirmFieldDef[] = [
  { key: 'vehicle', label: '车辆名称', editable: false },
  { key: 'vin', label: 'VIN', editable: false },
  { key: 'driveType', label: '驱动形式', editable: false },
  { key: 'subject', label: '项目名称', editable: false },
  { key: 'stage', label: '生产阶段', editable: false },
  { key: 'swVersion', label: '软件版本', editable: false },
  { key: 'testItem', label: '测试类型', editable: false },
  { key: 'testDate', label: '测试日期', editable: false },
  { key: 'driver', label: '驾驶员', editable: false },
  { key: 'tester', label: '测试员', editable: false },
];

/**
 * "是否带挂"（trailer）：车辆属性，但车辆档案可能未提供，且语义需驾驶员确认。
 * 故作为可编辑布尔字段（渲染为"带挂/不带挂"选项），而非只读预填。
 */
export const TRAILER_FIELD: ConfirmFieldDef = {
  key: 'trailer',
  label: '是否带挂',
  editable: true,
  boolean: true,
};

/** OTI 语音采集字段：可编辑 */
export const OTI_VOICE_FIELDS: ConfirmFieldDef[] = [
  { key: 'testLocation', label: '测试地点', editable: true },
  { key: 'weather', label: '天气', editable: true },
  { key: 'temperature', label: '温度', editable: true },
  { key: 'failureDateTime', label: '发生时间', editable: true },
  { key: 'mileageKm', label: '行驶里程(km)', editable: true },
  { key: 'heading', label: '问题简述', editable: true },
  { key: 'description', label: '用户描述', editable: true, textarea: true },
  { key: 'action', label: '操作', editable: true, textarea: true },
  { key: 'expectedBehavior', label: '预期表现', editable: true, textarea: true },
  { key: 'actualBehavior', label: '实际表现', editable: true, textarea: true },
  { key: 'frequency', label: '频率', editable: true },
  { key: 'immediateFix', label: '恢复方式', editable: true, textarea: true },
];

/** LP 语音采集字段：可编辑 */
export const LP_VOICE_FIELDS: ConfirmFieldDef[] = [
  { key: 'testLocation', label: '测试地点', editable: true },
  { key: 'weather', label: '天气', editable: true },
  { key: 'temperature', label: '温度', editable: true },
  { key: 'inspectionDateTime', label: '检车时间', editable: true },
  { key: 'mileageKm', label: '行驶里程(km)', editable: true },
  { key: 'heading', label: '问题简述', editable: true },
  { key: 'partName', label: '零件名称', editable: true },
  { key: 'description', label: '用户描述', editable: true, textarea: true },
];

/** 派生字段：自动拼装，只读展示 */
export const DERIVED_FIELDS: ConfirmFieldDef[] = [
  { key: 'eventDescription', label: '事件详情', editable: false, textarea: true },
];

/** 按报告类型返回确认卡片字段定义 */
export function getConfirmFieldDefs(reportType: 'OTI' | 'LP'): ConfirmFieldDef[] {
  const voice = reportType === 'OTI' ? OTI_VOICE_FIELDS : LP_VOICE_FIELDS;
  // "是否带挂"作为可编辑布尔字段，放在语音采集字段之前，供驾驶员确认
  return [...BASIC_FIELDS, TRAILER_FIELD, ...voice, ...DERIVED_FIELDS];
}
